import { render } from "./InputDatePicker.vue?vue&type=template&id=1fc493e6"
import script from "./InputDatePicker.vue?vue&type=script&lang=js"
export * from "./InputDatePicker.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__